import request from '@/utils/request'

export function orderList (query) {
  return request({
    url: '/front/order/list/',
    method: 'get',
    params: query
  })
}

export function orderSimpleInfo (orderId) {
  return request({
    url: '/front/order/' + orderId + '/simple/info/',
    method: 'get'
  })
}

export function orderCreateCheckout (clazzId, data) {
  return request({
    url: '/front/clazz/' + clazzId + '/checkout/',
    method: 'post',
    data
  })
}

export function raceOrderCreateCheckout (raceId, data) {
  return request({
    url: '/front/race/' + raceId + '/checkout/',
    method: 'post',
    data
  })
}

export function orderCancel (orderId) {
  return request({
    url: '/front/order/' + orderId + '/cancel/',
    method: 'post'
  })
}

export function orderPay (orderId) {
  return request({
    url: '/front/order/' + orderId + '/pay/',
    method: 'post'
  })
}
